export default __webpack_public_path__ + "static/media/circleRed.6ba03061.gif";